<template>
  <section id="wizard-step-1" class="form-content">
    <sc-form :form="formContent" :has-style="false" :rules="rules" @submit="(val) => $emit('onNextStep', val)">
      <template slot="fields" slot-scope="{ fields }">
        <section class="upload-form">
          <sc-field id="template-step-1" class="upload-form__step" prop="lpAndDmInfo">
            <template slot="label">
              <span class="upload-form__step__label">
                <sc-tag size="is-medium" rounded>1</sc-tag>
                Transportadora e método de entrega
              </span>
            </template>
            <sc-select
              size="is-medium"
              :disabled="loadingLogisticProviders"
              v-model="fields.lpAndDmInfo"
              placeholder="Transportadora e método de entrega"
              expanded>

              <option v-for="dm in allDeliveryMethods" :key="dm.id" :value="dm">
                {{ dm.logistic_provider_name }} - {{ dm.name }}
              </option>
            </sc-select>
          </sc-field>
          <sc-field id="template-step-2" class="upload-form__step" prop="name">
            <template slot="label">
              <span class="upload-form__step__label">
                <sc-tag size="is-medium" rounded>2</sc-tag>
                Nome do modelo da fatura
              </span>
            </template>
            <sc-input size="is-medium" v-model="fields.name" placeholder="Ex: Fatura transportadora ABC" />
          </sc-field>
          <sc-field id="template-step-3" class="upload-form__step" prop="previewFile">
            <template slot="label">
              <span class="upload-form__step__label">
                <sc-tag size="is-medium" rounded>3</sc-tag>
                Upload do arquivo do modelo de fatura
              </span>
            </template>
            <sc-simple-upload
              v-model="fields.previewFile"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              expanded drag-drop>
              <a class="button is-fullwidth is-medium">
                <span v-if="fields.previewFile">
                  <sc-tag class="selected-file" size="is-medium">
                    {{ fields.previewFile.name }}
                    <button class="delete is-small" type="button" @click="() => fields.previewFile = null"/>
                  </sc-tag>
                </span>
                <span v-else>
                  <i class="fas fa-upload" style="margin-right: .5em"></i>
                  Arraste um arquivo ou <strong>clique</strong> para buscar
                </span>
              </a>
            </sc-simple-upload>
          </sc-field>
        </section>
      </template>
      <template slot="actions" slot-scope="{ isValid }">
        <section class="continue-buttom">
          <sc-button theme="primary" type="submit" text="Continuar"/>
        </section>
      </template>
    </sc-form>
  </section>
</template>

<script>
import { ScField, ScSelect, ScInput, ScSimpleUpload, ScTag, ScButton, ScForm, ScIcon, ScCard } from '@intelipost-js/secure-components';
import { Lodash } from '@intelipost-js/secure-providers';

export default {
  name: 'billingTemplateStep1',
  components: {
    ScField, ScSelect, ScInput, ScSimpleUpload, ScTag, ScButton, ScForm, ScIcon, ScCard,
  },
  data() {
    return {
      loadingLogisticProviders: false,
      formContent: {
        name: null,
        lpAndDmInfo: null,
        previewFile: undefined,
      },
    };
  },
  computed: {
    rules() {
      return {
        name: [{ required: true, message: 'Escreva o nome do modelo' }],
        lpAndDmInfo: [{ required: true, message: 'Selecione a transportadora e o método de entrega' }],
        previewFile: [{ required: true, trigger: 'submit', validator: this.previewFileValidator }],
      };
    },
    allDeliveryMethods() {
      return this.$store.getters['logisticProviders/allDeliveryMethods'];
    },
  },
  methods: {
    previewFileValidator: (rule, file, callback) => {
      const errors = [];
      if (file === undefined) {
        errors.push(
          new Error('Para continuar, selecione um arquivo do modelo da fatura.', rule.field),
        );
      } else if (file && file.size && file.size > 100000) {
        errors.push(
          new Error('Tamanho do arquivo não permitido (máximo 100 kb). Tente deixar apenas o cabeçalho da fatura para a criação do modelo.', rule.field),
        );
      }
      callback(errors);
    },
  },
  async created() {
    if (Lodash.isEmpty(this.$store.getters['logisticProviders/allDeliveryMethods'])) {
      this.loadingLogisticProviders = true;
      await this.$store.dispatch('logisticProviders/getLogisticProviders', true);
      this.loadingLogisticProviders = false;
    }
  },
};

</script>
<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
#template-step-3 {
  .upload .upload-draggable {
    padding: 0;
    border: none;

    &.is-hovered {
      border: 1px dashed $grey-light;
      background: rgba($grey-light, 0.5);
    }

    .button {
      justify-content: left !important;

      .selected-file > span {
        display: flex;
        align-items: center;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep1.vue